module.exports = __webpack_public_path__ + "media/images/NPort_banner-63c2ed9b530d1936d4388d1e5e7123a1.jpg";